import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=50b64bf6&scoped=true&"
import script from "./editUser.vue?vue&type=script&lang=js&"
export * from "./editUser.vue?vue&type=script&lang=js&"
import style0 from "./editUser.vue?vue&type=style&index=0&id=50b64bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b64bf6",
  null
  
)

export default component.exports